import { NavigationData, Position } from "../../config/interactive/types";
import { uiZIndexDefault } from "../../config/interactive/constants";

export const mapPosToStyle = (position: Position) => {
	return {
		left: `${position.x}%`,
		top: `${position.y}%`,
		width: `${position.width}%`,
		height: `${position.height}%`,
		transform: `rotate(${position.rotation || 0}deg)`,
		zIndex: `${position.zIndex ? uiZIndexDefault + position.zIndex : uiZIndexDefault}`,
	};
};

export const setDataNavValues = (data?: NavigationData) => {
	if (!data) {
		return {};
	}
	return {
		id: data?.id,
		"data-up": data?.up,
		"data-down": data?.down,
		"data-left": data?.left,
		"data-right": data?.right,
	};
};
